import { createAction } from 'redux-actions';

import { CLEAR_CLIENT_PROFILE_ENTRY_STATUS } from '../../types';

export const clearClientProfileEntryStatus = createAction(CLEAR_CLIENT_PROFILE_ENTRY_STATUS);


// WEBPACK FOOTER //
// ./src/features/client-profile/actions/clearActions/clearClientProfileDetailsEntryStatusActions.js